/* eslint-disable no-mixed-operators */
/* global G */
import { getDraftUrl, getRefKeys, getUrl, noLoaderMiddleware } from '@platform/adapter/message/helper'
import { defaultMiddleware } from 'platform/adapter/http/middleware'

/**
 * Adds a message to the adapter's G.DATA list of messages, dispatches a G.DONE event and then
 * attempts to send it to the server. On successful send, it sets the new message's id and rev and
 * submitTimestamp, adds it to the adapter's data and dispatches a G.DONE event again.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 */
const fn = app => async ({ detail }) => {
  const adapter = app[G.ADAPTER][G.MESSAGE]
  const eventBus = app[G.ADAPTER][G.EVENTS]
  const adapterData = adapter[G.DATA]
  const { draft, ...item } = detail[G.DATA]
  const hasAttachments = detail[G.ATTACHMENT]
  const callback = detail[G.FN]
  adapterData.push(item)

  // Initializing the loader if we have attachments
  hasAttachments && eventBus.dispatch(eventBus.type(G.LOAD, G.INIT))

  /**
   * Why do we dispatch the same event here and then later below?
   * Because we want to show the message in the chat window already while
   * it's sending to the server with the 'Sending...' footer.
   */
  eventBus.dispatch(eventBus.type(G.MESSAGE, G.DONE), { [G.DATA]: adapterData })

  const url = draft
    ? getDraftUrl(app)
    : `${getUrl(app)}/default`

  const result = await app[G.ADAPTER][G.HTTP][G.API].post({ url, params: item }, {
    middleware: hasAttachments
      ? noLoaderMiddleware
      : defaultMiddleware,
  })

  if (result) {
    const { data = result } = result

    draft
      && (item.key = data[0].id)
      && (item._rev = data[0].rev)
      && (item.draft = true)

    !draft
      && (item.key = data.key)
      && (item._rev = data._rev)
      && (item.value = data.value)
      && (item.refs = getRefKeys(data.refs))
      && (item.acl = data.acl)

    const done = await callback?.(item)

    // Closing the loader
    done && hasAttachments && eventBus.dispatch(eventBus.type(G.LOAD, G.DONE))

    eventBus.dispatch(eventBus.type(G.MESSAGE, G.DONE), { [G.DATA]: adapterData })
  }
}

export default fn
